import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88dfa044"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trust-data-external-examiner-approval" }
const _hoisted_2 = { class: "section-heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Maintain trust data", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "ATCS External Examiner to Practice approval", -1))
const _hoisted_5 = { class: "search" }
const _hoisted_6 = { class: "search-inputs" }
const _hoisted_7 = { class: "search-bar" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-hm" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search fa-lg" })
], -1))
const _hoisted_9 = { class: "checkbox-button ml-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Submitted")
], -1))
const _hoisted_11 = { class: "checkbox-button ml-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Approved")
], -1))
const _hoisted_13 = { class: "checkbox-button ml-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Rejected")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "space-filler",
  style: {"flex-grow":"1"}
}, null, -1))
const _hoisted_16 = { class: "table-section" }
const _hoisted_17 = { class: "ls-table" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["colspan"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["colspan"]
const _hoisted_22 = { key: 2 }
const _hoisted_23 = ["colspan"]
const _hoisted_24 = { "data-label": "Practice Name" }
const _hoisted_25 = ["title"]
const _hoisted_26 = { "data-label": "Form Type" }
const _hoisted_27 = { "data-label": "Actions" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_TrustDataExternalExaminerModal = _resolveComponent("TrustDataExternalExaminerModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchText) = $event)),
              placeholder: "Search Practice name or ID"
            }, null, 512), [
              [_vModelText, _ctx.searchText]
            ]),
            _hoisted_8
          ]),
          _createElementVNode("label", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.isSubmitted) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.isSubmitted]
            ]),
            _hoisted_10
          ]),
          _createElementVNode("label", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.isApproved) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.isApproved]
            ]),
            _hoisted_12
          ]),
          _createElementVNode("label", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.isRejected) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.isRejected]
            ]),
            _hoisted_14
          ]),
          _hoisted_15,
          _createElementVNode("button", {
            class: "btn btn-secondary mr-2",
            onClick: _cache[4] || (_cache[4] = $event => (_ctx.loadData()))
          }, "Apply filter")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("table", _hoisted_17, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", null, [
                _createElementVNode("div", null, _toDisplayString(h.text), 1)
              ]))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                _createElementVNode("td", {
                  colspan: _ctx.tableHeadings.length
                }, [
                  _createVNode(_component_LoadingIndicator)
                ], 8, _hoisted_19)
              ]))
            : (_ctx.errorLoadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                  _createElementVNode("td", {
                    colspan: _ctx.tableHeadings.length
                  }, [
                    _createVNode(_component_ErrorIndicator)
                  ], 8, _hoisted_21)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.filteredSoftwareList.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                    _createElementVNode("td", {
                      colspan: _ctx.tableHeadings.length
                    }, "No results found", 8, _hoisted_23)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.filteredSoftwareList.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.filteredSoftwareList, (ee) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", _hoisted_24, _toDisplayString(ee.practice?.practiceName), 1),
                        _createElementVNode("td", {
                          "data-label": "Address",
                          title: ee.practice?.address
                        }, _toDisplayString(ee.practice?.address), 9, _hoisted_25),
                        _createElementVNode("td", _hoisted_26, _toDisplayString(ee.eeRequestFormType?.name), 1),
                        _createElementVNode("td", {
                          "data-label": "Status",
                          class: _normalizeClass('status-'+ee.eeRequestFormStatus?.id)
                        }, _toDisplayString(ee.eeRequestFormStatus?.name), 3),
                        _createElementVNode("td", _hoisted_27, [
                          (ee.eeRequestFormStatus?.id == 1)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("button", {
                                  class: "btn btn-default sml ml-2 mr-2",
                                  onClick: $event => (_ctx.openModal(ee, 1))
                                }, "Approve", 8, _hoisted_28),
                                _createElementVNode("button", {
                                  class: "btn btn-default sml",
                                  onClick: $event => (_ctx.openModal(ee, 2))
                                }, "Reject", 8, _hoisted_29)
                              ], 64))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-default sml ml-2",
                                onClick: $event => (_ctx.openModal(ee, 3))
                              }, "View", 8, _hoisted_30))
                        ])
                      ]))
                    }), 256))
                  : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.showEEModal)
      ? (_openBlock(), _createBlock(_component_TrustDataExternalExaminerModal, {
          key: 0,
          formType: _ctx.formType,
          "onUpdate:formType": _cache[5] || (_cache[5] = $event => ((_ctx.formType) = $event)),
          selectedEE: _ctx.selectedEE,
          "onUpdate:selectedEE": _cache[6] || (_cache[6] = $event => ((_ctx.selectedEE) = $event)),
          onReloadData: _ctx.loadData,
          onCloseEEModal: _cache[7] || (_cache[7] = $event => {_ctx.showEEModal = false;}),
          actionType: _ctx.actionType,
          "onUpdate:actionType": _cache[8] || (_cache[8] = $event => ((_ctx.actionType) = $event))
        }, null, 8, ["formType", "selectedEE", "onReloadData", "actionType"]))
      : _createCommentVNode("", true)
  ]))
}